import Splide from '@splidejs/splide';
import '@splidejs/splide/dist/css/themes/splide-default.min.css';

export function blockOpinionsGfSliderScript() {
    document.addEventListener( 'DOMContentLoaded', function () {
        const opinionsGFblock = document.querySelectorAll('.opinionsgf__slider');

        opinionsGFblock.forEach(block=>{
            let opinionsGF = new Splide(block, {
                type  : 'loop',
                // rewind: false,
                // autoplay: false,
                perPage: 2,
                gap: 23,
                padding: { left: '15rem', right: '35rem'},
                perMove: 1,
                pagination:false,
                arrows: false,
                // interval: 0,
                // speed: 8000,
                breakpoints: {
                    1100: { perPage: 1 },
                    992: { padding: { left: '7rem', right: '20rem'}, perPage: 1 },
                    599: { padding: { left: '0rem', right: '5rem'}, perPage: 1 },
                },
            });

            opinionsGF.mount()
        });
    })
}